import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productList: [],
  productDetail: [],
  loading: false,
  error: undefined,
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchProductList(state, action) {
      state.productList = action.payload;
      state.loading = false;
    },
    fetchProductDetail(state, action) {
      state.productDetail = action.payload;
      state.loading = false;
    },
  },
});

export const productActions = productSlice.actions;

export default productSlice.reducer;
